import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";

export default function SettingsPopup({
  showPopup,
  setShowPopup,
  initialState = [],
  finalState = [],
  setFinalState,
  order = [],
}) {
  const updateState = (id) => {
    const fieldExist = finalState.find((state) => state.id == id);
    if (fieldExist) {
      setFinalState((prevState) => prevState.filter((data) => data.id != id));
    } else {
      setFinalState((prevState) => [
        ...prevState,
        initialState.find((state) => state.id == id),
      ]);
    }
    if (order.length > 0) {
      setFinalState((data) =>
        data.sort((a, b) => {
          const aValue = order.indexOf(a.value);
          const bValue = order.indexOf(b.value);
          // Handle the case where a value is not present in orderArray
          if (aValue === -1 && bValue === -1) {
            return 0; // No change in order for values not in orderArray
          } else if (aValue === -1) {
            return 1; // Move items not in orderArray to the end
          } else if (bValue === -1) {
            return -1; // Move items not in orderArray to the end
          }
          return aValue - bValue;
        })
      );
    } else {
      setFinalState((data) => data.sort((a, b) => a.id - b.id));
    }
  };
  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        showPopup ? "flex" : "hidden"
      }`}
    >
      <div className="max-w-md w-[80%] h-auto min-h-[20rem]  rounded-md bg-white/95 flex  flex-col p-4 relative">
        <div className="flex justify-between items-center w-full">
          <h1 className="text-xl font-semibold">Show more fields</h1>
          <h1
            className="text-md font-semibold cursor-pointer"
            onClick={() => {
              setShowPopup(false);
            }}
          >
            <IoMdClose />
          </h1>
        </div>
        <div className="flex justify-center">
          <div className="w-full max-w-sm  grid grid-cols-1 md:grid-cols-2 gap-2 items-center my-3 overflow-y-auto max-h-[15rem]">
            {initialState.map((data) => (
              <div className="form-control " key={data.id}>
                <label className="label justify-start cursor-pointer gap-3">
                  <input
                    type="checkbox"
                    className="checkbox"
                    defaultChecked={
                      finalState.find((state) => state.id == data.id)
                        ? true
                        : false
                    }
                    onChange={() => updateState(data.id)}
                    disabled={
                      initialState.find((state) => state.id == data.id)?.default
                        ? true
                        : false
                    }
                  />
                  <span className="label-text">{data.title}</span>
                </label>
              </div>
            ))}
          </div>
        </div>

        <div className="flex mt-auto gap-3 min-w-fit w-full p-5 justify-center ">
          <button
            className="p-2 w-full rounded-md ring-1 ring-slate-600"
            type="button"
            onClick={() => {
              setShowPopup(false);
            }}
          >
            Cancel
          </button>
          <button
            className="p-2 w-full rounded-md ring-1 ring-red text-white bg-red"
            type="button"
            onClick={() => {
              setFinalState(finalState);
              setShowPopup(false);
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
}
